import { Injectable } from '@angular/core';
import { select, Store } from '@ngrx/store';

import { getUserHistoryEntries } from './history.selectors';

@Injectable()
export class UserHistoryFacade {
  userHistory$ = this.store.pipe(select(getUserHistoryEntries));

  constructor(private readonly store: Store) {}
}
